export const constants = {
  MFE_CONFIGURATIONS_NAME: 'configurations',
  MFE_EXPOSED_PATH: './ConfigurationsApp',
};
